/**
 * ResourceSettingsService
 * Admin GET/PUT for the singleton Resource Centre platform settings, plus a
 * public (anonymous-safe) read for the public Resource Centre site.
 * Route: api/resource-settings
 */
import { BaseService } from '../base/BaseService';
export class ResourceSettingsService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ResourceSettingsService.DEFAULT_SERVICE_PATH,
            basePath: ResourceSettingsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** Admin: read the current settings. */
    async getSettings() {
        const response = await this.getSettingsRaw();
        return response.data ?? null;
    }
    getSettingsRaw() {
        return this.http.get(this.buildUrl(''));
    }
    /** Admin: persist the settings. */
    async updateSettings(settings) {
        const response = await this.updateSettingsRaw(settings);
        return response.data ?? null;
    }
    updateSettingsRaw(settings) {
        return this.http.put(this.buildUrl(''), settings);
    }
    /** Public: anonymous-safe subset for the public Resource Centre site. */
    async getPublicSettings() {
        const response = await this.getPublicSettingsRaw();
        return response.data ?? null;
    }
    getPublicSettingsRaw() {
        return this.http.get(this.buildUrl('public'));
    }
    /** Admin: read the media switches (HLS playback, transcripts, listen mode, audio download). */
    async getMediaSettings() {
        const response = await this.getMediaSettingsRaw();
        return response.data ?? null;
    }
    getMediaSettingsRaw() {
        return this.http.get(this.buildUrl('media'));
    }
    /** Admin: persist the media switches. Leaves every other setting untouched. */
    async updateMediaSettings(settings) {
        const response = await this.updateMediaSettingsRaw(settings);
        return response.data ?? null;
    }
    updateMediaSettingsRaw(settings) {
        return this.http.put(this.buildUrl('media'), settings);
    }
}
ResourceSettingsService.DEFAULT_SERVICE_PATH = 'resources';
ResourceSettingsService.BASE_PATH = 'api/resource-settings';
//# sourceMappingURL=ResourceSettingsService.js.map